import React from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import LottieAnimation from '../../../assets/animation/LottieAnimation';
import AppList from '../../../assets/data/audience/apps.json';

const AudienceManuallyPreviewModal = ({ isOpen, toggle, isLoading, previewData, handleConfirm }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getAppPackageInfo = (bundleId) => {
    const app = AppList.find(app => app.bundleId === bundleId);
    return app ? app.packageInfo : bundleId;
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="modal-dialog modal-lg">
      <ModalHeader toggle={toggle}>Audience Manually Preview</ModalHeader>
      <ModalBody>
        {isLoading ? (
          <LottieAnimation />
        ) : (
          <>
            {previewData ? (
              <>
                <p><strong>Name:</strong> {previewData.name}</p>
                <p><strong>OS Type:</strong> {previewData.osType}</p>
                <p><strong>User Status:</strong> {previewData.userStatus}</p>
                {previewData.selectedProfiles && previewData.selectedProfiles.length > 0 && (
                  <p><strong>Selected Profiles:</strong> {previewData.selectedProfiles.join(', ')}</p>
                )}
                <p><strong>Time Range:</strong> {`From ${formatDate(previewData.timeRange.startDate)} to ${formatDate(previewData.timeRange.endDate)}`}</p>
                {previewData.audienceComment && (
                  <p><strong>Comment:</strong> {previewData.audienceComment}</p>
                )}
                {previewData.generations && previewData.generations.length > 0 && (
                  <p><strong>Generations:</strong> {previewData.generations.join(', ')}</p>
                )}
                {previewData.genders && previewData.genders.length > 0 && (
                  <p><strong>Genders:</strong> {previewData.genders.join(', ')}</p>
                )}
                {previewData.app && previewData.app.inApps && previewData.app.inApps.length > 0 && (
                  <p><strong>Include Apps:</strong> {previewData.app.inApps.map(getAppPackageInfo).join(', ')}</p>
                )}
                {previewData.app && previewData.app.notInApps && previewData.app.notInApps.length > 0 && (
                  <p><strong>Exclude Apps:</strong> {previewData.app.notInApps.map(getAppPackageInfo).join(', ')}</p>
                )}
                {previewData.locations && previewData.locations.length > 0 && (
                  <div>
                    <strong>Locations:</strong>
                    <ul>
                      {previewData.locations.map((location, index) => (
                        <li key={index}>{`Lat: ${location.lat}, Lon: ${location.lon}, Radius: ${location.meter}m`}</li>
                      ))}
                    </ul>
                  </div>
                )}
                <div className="hstack gap-2 justify-content-end">
                  <Button color="secondary" onClick={toggle}>Cancel</Button>
                  <Button color="success" onClick={handleConfirm}>Confirm</Button>
                </div>
              </>
            ) : (
              <p>Preview data is not available.</p>
            )}
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default AudienceManuallyPreviewModal;
